import { render, staticRenderFns } from "./PartialbankdraftTemplateComponent.vue?vue&type=template&id=550544b1&scoped=true&lang=pug"
import script from "./PartialbankdraftTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./PartialbankdraftTemplateComponent.vue?vue&type=script&lang=ts"
import style0 from "./PartialbankdraftTemplateComponent.vue?vue&type=style&index=0&id=550544b1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550544b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('550544b1')) {
      api.createRecord('550544b1', component.options)
    } else {
      api.reload('550544b1', component.options)
    }
    module.hot.accept("./PartialbankdraftTemplateComponent.vue?vue&type=template&id=550544b1&scoped=true&lang=pug", function () {
      api.rerender('550544b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/PartialbankdraftTemplateComponent.vue"
export default component.exports